<!--
  Empty state. Branded rather than blank: the directive keeps room for ShioCast personality
  in exactly these moments, while operational surfaces stay plain.
-->
<script setup lang="ts">
defineProps<{ title: string; description?: string }>();
</script>

<template>
  <div class="shio-empty">
    <div class="shio-empty__mark" aria-hidden="true">
      <slot name="icon">SC</slot>
    </div>
    <p class="shio-card-title">{{ title }}</p>
    <p v-if="description" class="shio-body-sm">{{ description }}</p>
    <div v-if="$slots.action"><slot name="action" /></div>
  </div>
</template>

<style scoped>
.shio-empty__mark {
  font-family: var(--shio-font-display);
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: hsl(var(--shio-accent-primary) / 0.45);
}
</style>
